(function () {
  'use strict';

  function formatMoney(cents, element) {
    var moneyFormat = element.dataset.moneyFormat || '${{amount}}';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    var currency = element.dataset.currency || 'USD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function updateDisplay(element, variantPrice) {
    var price = Number(variantPrice);
    var dutyPercent = Number(element.dataset.dutyPercent || 50);
    var discountPercent = Number(element.dataset.discountPercent || 0);

    if (!Number.isFinite(price)) {
      element.hidden = true;
      return;
    }

    // Shopify rounds the automatic percentage discount to the customer's
    // benefit at the line-item level (for example, $97.99 becomes $73.50).
    var merchandisePrice = Math.ceil(price * (100 - discountPercent) / 100);
    var dutyAmount = Math.round(merchandisePrice * dutyPercent / 100);
    var landedTotal = merchandisePrice + dutyAmount;

    element.hidden = false;
    element.querySelector('[data-us-merchandise-price]').textContent = formatMoney(merchandisePrice, element);
    element.querySelector('[data-us-duty-amount]').textContent = formatMoney(dutyAmount, element);
    element.querySelector('[data-us-landed-total]').textContent = formatMoney(landedTotal, element);
  }

  function initializeDisplay(element) {
    if (element.dataset.usDutyInitialized === 'true') return;

    element.dataset.usDutyInitialized = 'true';
    updateDisplay(element, element.dataset.initialPrice);

    var section = element.closest('.shopify-section') || document;
    var variantSelection = section.querySelector('[data-variant-selection]');

    if (variantSelection) {
      variantSelection.addEventListener('variant-change', function (event) {
        var variant = event.detail && event.detail.variant;

        if (variant && typeof variant.price !== 'undefined') {
          updateDisplay(element, variant.price);
        } else {
          element.hidden = true;
        }
      });
    }
  }

  function initializeAll(scope) {
    var displays = (scope || document).querySelectorAll('[data-us-duty-price-display]');

    for (var i = 0; i < displays.length; i += 1) {
      initializeDisplay(displays[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
}());
